import React,{useEffect,useState} from 'react'
import { DataGrid } from '@mui/x-data-grid';
import clinicService from '../../../../../services/clinic.service';

function CommentsTable({clinicid}) {
  const [comments,setComments] = useState([])
  const [pageNo,setPageNo] = useState(0)
  const [pageSize,setPageSize] = useState(5)
  const [rowCount,setRowCount] = useState(10)
  const [paginationModel,setPaginationModel] = useState({
    page:0,
    pageSize:5,
 })
  const columns = [
    {field:"id", headerName:"ID",width:'40'},
    {field:"patientId", headerName:'Patient Id',width:'40'},
    {field:"patientUUID",headerName:'UUID',width:250},
    {field:"firstName",headerName:'FirstName',width:100},
    {field:"lastName",headerName:'LastName',width:100},
    {field:'notes',headerName:'Notes',width:350},
  ]

  useEffect(()=>{
     getComments(clinicid,paginationModel.page,paginationModel.pageSize)
  },[paginationModel.page])

  const getComments = (clinicid,pageNo,pageSize)=>{
      clinicService.getReputationComments(clinicid,pageNo,pageSize)
      .then(res=>{
        setComments(res.data.content)
        setRowCount(res.data.totalElements)
      })
      .catch(err=>{
        console.log(err)
      })
  }
  return (
    <div className="mb-4" style={{  width: '100%' }}>
      <h5>Comments</h5>
      <DataGrid
        rows={comments}
        columns={columns}
        rowCount={rowCount}
        pagination
       paginationModel={paginationModel}
        pageSizeOptions={[5, 10]}
        paginationMode='server'
        onPaginationModelChange={setPaginationModel}
       />
    </div>
  )
}

export default CommentsTable